
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
export default BaseCmsBlock.extend({
  name: "WhyOurDeliveryFasterBlock",

  computed: {
    isVisible: function () {
      const device = this.$store.state.device?.device;

      const isMobile = Boolean(this.cfgs?.visible_mobile && device?.isMobile);
      const isTablet = Boolean(this.cfgs?.visible_laptop && device?.isTablet);
      const isDesktop = Boolean(this.cfgs?.visible_pc && device?.isDesktop);

      return Boolean(isMobile || isTablet || isDesktop)
    }
  },

  methods: {
    openForm: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Заказать звонок',
          hideTabs: true,
        }
      });
    }
  }
})
